import React, { createContext, useContext } from "react";
import { useHotjarSurveys } from "../hooks/useHotjarSurveys";

const HotjarContext = createContext(null);

export function HotjarProvider({ children }) {
  const hotjar = useHotjarSurveys();

  return (
    <HotjarContext.Provider value={hotjar}>{children}</HotjarContext.Provider>
  );
}

export function useHotjar() {
  const context = useContext(HotjarContext);

  if (!context) {
    throw new Error("useHotjar must be used inside HotjarProvider");
  }

  return context;
}
